/*global _ */
import props from './../../../../props/inputs'
export const allProps = {
  ...props,
  containerClass: {
    default: ''
  },
  inputComponent: {
    default: 're-input'
  },
  inputAttr: {
    type: Object,
    default: () => ({

    })
  },
  buttonComponent: {
    default: 're-button'
  },
  buttonAttr: {
    type: Object,
    default: () => ({
      title: 'Apply'
    })
  },

  disableInputOnApply: {
    default: true
  },
  buttonClass: {
    default: ''
  },
  isResetNeeded: {
    default: true
  },
  clearOnReset: {
    default: true
  },
  applyOnKeys: {
    default: true
  },
  applyOnReset: {
    default: true
  },
  resetButtonComponent: {
    default: 're-button'
  },
  resetButtonAttr: {
    type: Object,
    default: () => ({
      title: 'Reset'
    })
  },
  resetButtonClass: {
    default: ''
  },
  resetValue: {
    default: ''
  }
}
export default allProps
